import { track } from "@amplitude/analytics-react-native";
import { useApolloClient } from "@apollo/client";
import SetPhotoReactionDocument from "src/api/graphql/__generated__/documents/SetPhotoReactionDocument";
import { ReactionAssetFragmentFragment } from "src/api/graphql/__generated__/graphql";
import ReactionBadge from "src/components/ReactionBadge";
import TouchableScale from "src/components/TouchableScale";
import haptic from "src/helpers/haptic";
import { PhotoItem } from "src/screens/(internal)/PhotoDetailModal/types";

const ReactionButton = ({
	isSelected,
	gatheringId,
	photo,
	reactionAsset,
}: {
	isSelected: boolean;
	gatheringId: string;
	photo: PhotoItem;
	reactionAsset: ReactionAssetFragmentFragment;
}) => {
	const apolloClient = useApolloClient();
	return (
		<TouchableScale
			onPress={async () => {
				if (isSelected) {
					haptic("Light");
					track("photoUnreact", {
						emoji: reactionAsset.emoji,
						photoId: photo.photoId,
						gatheringId,
					});
				} else {
					haptic("Heavy");
					track("photoReact", {
						emoji: reactionAsset.emoji,
						photoId: photo.photoId,
						gatheringId,
					});
				}
				await apolloClient.mutate({
					mutation: SetPhotoReactionDocument,
					variables: {
						input: {
							photoId: photo.photoId,
							gatheringId,
							hasPrimaryReaction: !isSelected,
						},
					},
					optimisticResponse: {
						__typename: "Mutation",
						setPhotoReaction: {
							__typename: "Photo",
							photoId: photo.photoId,
							numPrimaryReaction:
								(photo.numPrimaryReaction ?? 0) + (isSelected ? -1 : 1),
							callerReaction: {
								__typename: "Reaction",
								didPrimaryReact: !isSelected,
							},
						},
					},
				});
			}}
		>
			<ReactionBadge reactionAsset={reactionAsset} sizeVariant="md" isSelected={isSelected} />
		</TouchableScale>
	);
};
export default ReactionButton;
